import { EnvelopeSimple } from '@phosphor-icons/react'
import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const IntegrationCardMail = ({
  className,
  children,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn('flex items-center gap-1 text-sm text-gray-500', className)}
    {...props}
  >
    <EnvelopeSimple className="-mb-0.5 text-base" />
    {children}
  </div>
)
